import { Button, Container } from "react-bootstrap";
import { useEffect, useState } from "react";
function HomeLanding() {
  const [activeFlow, setActiveFlow] = useState(0);

  useEffect(() => {
    const buttons = document.querySelectorAll("#landing-cases button");
    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        setActiveFlow(index);
        buttons.forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");
      });
    });
  }, []);

  return (
    <section id="home-landing" className="text-center">
      <Container>
        <div className="d-flex align-items-center flex-column">
          <h1 className="my-5 display-3">
            Lorem ipsum dolor sit amet,
            <br />
            consectetur adipiscing.
          </h1>
          <div className="w-50">
            <p>
              Your customer drives through sleek, modern cameras installed at
              your site. Lorem ipsum dolor sit amet, consectetur adipiscing.
            </p>
          </div>
        </div>

        <div className="my-5">
          <Button className="btn white me-3">Log in</Button>
          <Button className="btn outline">Get a demo</Button>
        </div>

        <div id="landing-cases" className="d-flex justify-content-center">
          <div className="w-50 d-flex justify-content-between">
            <Button className="active">
              <div>
                <i class="fa-light fa-wrench"></i>Repairer
              </div>
            </Button>
            <Button>
              <div>
                <i class="fa-light fa-key"></i>Leaser
              </div>
            </Button>
            <Button>
              <div>
                <i class="fa-light fa-money-bill-simple-wave"></i>Dealer
              </div>
            </Button>
            <Button>
              <div>
                <i class="fa-light fa-calculator"></i>Appraiser
              </div>
            </Button>
          </div>
        </div>

        <img
          src="https://prooftec.com/wp-content/uploads/2025/01/Group-93-1.png"
          alt="ProofTec Demo"
          className="cover-img"
        />
      </Container>

      <img
        src="/assets/semi-circle.svg"
        alt="Semi Circle"
        className="semi-circle"
      />
    </section>
  );
}

export default HomeLanding;
